// GENERATED FILE — do not hand-edit.
// Derived from router.config.ts by .design-sync/gen-router-menu.mjs, which
// mechanically strips every `component: LoadableComponent(...)` property
// (and the LoadableComponent import). Display-metadata-only mirror (name,
// icon, path, permission, nested group structure) — no import() calls, so
// consumers here never pull in the scenes tree. Re-run the script after any
// route/menu change in router.config.ts.

import {
  PieChartOutlined,
  ExceptionOutlined,
  LogoutOutlined,
  RadarChartOutlined,
  // TagsOutlined,
  // UserOutlined,
  // FolderOpenOutlined,
  SettingOutlined,
  CommentOutlined,
  SmileOutlined,
  SearchOutlined,
  ShoppingCartOutlined,
  ToolOutlined,
  CompassOutlined,
  InsertRowBelowOutlined,
  HomeOutlined,
  EnvironmentOutlined,
  DollarOutlined,
  CalendarOutlined,
  CreditCardOutlined,
  LineChartOutlined,
  BarChartOutlined,
  FileTextOutlined,
  RocketOutlined,
  LoginOutlined,
  OrderedListOutlined,
  FieldNumberOutlined,
  SyncOutlined,
  ReadOutlined,
  SoundOutlined,
  CloudDownloadOutlined
} from "@ant-design/icons"
import { ReactComponent as Contract } from "@assets/icons/Contract.svg"
import { ReactComponent as Bell } from "@assets/icons/Bell.svg"
import { ReactComponent as Cannon } from "@assets/icons/Cannon.svg"
import { ReactComponent as HandSpeaker } from "@assets/icons/HandSpeaker.svg"
import { ReactComponent as Headphone } from "@assets/icons/Headphone.svg"
import { ReactComponent as Key } from "@assets/icons/Key.svg"
import { ReactComponent as MasterData } from "@assets/icons/MasterData.svg"
import { ReactComponent as Notebook } from "@assets/icons/Notebook.svg"
import {
  CurrencyDollarIcon,
  TicketIcon,
  DocumentTextIcon,
} from "@heroicons/react/24/outline"
// import { ReactComponent as Stack } from "@assets/icons/Stack.svg"
import { ReactComponent as UsersThree } from "@assets/icons/UsersThree.svg"
import { ReactComponent as UsersTwo } from "@assets/icons/UsersTwo.svg"

import { appPermissions } from "@lib/appconst"
const hostname = window.location.origin

export const layouts: any = {
  userLayout: "userLayout",
  portalLayout: "appLayout",
  publicLayout: "publicLayout",
  guideReaderLayout: "guideReaderLayout",
}

export const publicLayout: any = {
  termAndCondition: {
    path: "/public/terms-and-conditions",
    title: "TERM_CONDITIONS",
    layout: layouts.userLayout,
  },
  proposalPublic: {
    path: "/public/proposal/:id",
    title: "PROPOSAL",
    layout: layouts.publicLayout,
  },
}

export const userLayout: any = {
  accountLogin: {
    path: "/account/login",
    title: "Login",
    name: "LOGIN",
    layout: layouts.userLayout,
  },
  forgotPassword: {
    path: "/account/forgot-password",
    title: "FORGOT_PASSWORD",
    name: "FORGOT_PASSWORD",
    layout: layouts.userLayout,
  },
  resetPassword: {
    path: "/account/reset-password",
    title: "RESET_PASSWORD",
    name: "RESET_PASSWORD",
    layout: layouts.userLayout,
  },
  // Self-registration flows removed: CRM là hệ thống nội bộ, tài khoản do
  // Administrator cấp — không cho phép tự đăng ký (an ninh).
}

export const portalLayouts: any =
  hostname === process.env.REACT_APP_EVENT_URL
    ? {
      // SALE EVENT WITH OTHER HOST NAME
      eventProgess: {
        path: "/event/progess",
        name: "EVENT_PROCESS",
        title: "EVENT_PROCESS",
        layout: layouts.portalLayout,
        icon: SettingOutlined,
      },
      eventDrawLots: {
        path: "/event/draw-lots",
        name: "DRAW_LOTS",
        title: "DRAW_LOTS",
        layout: layouts.portalLayout,
        icon: SettingOutlined,
      },
      pickUnits: {
        path: "/event/pick-units",
        name: "PICK_UNITS",
        title: "PICK_UNITS",
        layout: layouts.portalLayout,
        icon: SettingOutlined,
      },
      stackingLand: {
        path: "/event/stacking-land",
        name: "STACKING_LAND",
        title: "STACKING_LAND",
        layout: layouts.portalLayout,
        icon: SettingOutlined,
      },
    }
    : {
      dashboard: {
        path: "/dashboard",
        name: "DASHBOARD_REPORT",
        title: "DASHBOARD_REPORT",
        permission: appPermissions.dashboard.page,
        layout: layouts.portalLayout,
        icon: PieChartOutlined,
      },
      // Dashboard Suite (Feature-0196). Widget thật gắn ở Feature-0197…0200;
      // hiện trỏ tới scene placeholder để permission + menu + breadcrumb chạy end-to-end.
      dashboardExecutive: {
        path: "/dashboard-executive",
        name: "DASHBOARD_EXECUTIVE",
        title: "DASHBOARD_EXECUTIVE",
        permission: appPermissions.dashboard.executive,
        layout: layouts.portalLayout,
        icon: PieChartOutlined,
      },
      dashboardCs: {
        path: "/dashboard-cs",
        name: "DASHBOARD_CS",
        title: "DASHBOARD_CS",
        permission: appPermissions.dashboard.cs,
        layout: layouts.portalLayout,
        icon: PieChartOutlined,
      },
      dashboardFinance: {
        path: "/dashboard-finance",
        name: "DASHBOARD_ACC",
        title: "DASHBOARD_ACC",
        permission: appPermissions.dashboard.finance,
        layout: layouts.portalLayout,
        icon: PieChartOutlined,
      },
      dashboardSales: {
        path: "/dashboard-sales",
        name: "DASHBOARD_SA",
        title: "DASHBOARD_SA",
        permission: appPermissions.dashboard.sales,
        layout: layouts.portalLayout,
        icon: PieChartOutlined,
      },
      dailyCollection: {
        path: "/daily-collection",
        name: "DAILY_COLLECTION",
        title: "DAILY_COLLECTION",
        permission: appPermissions.report.dailyCollection,
        layout: layouts.portalLayout,
        icon: DollarOutlined,
      },
      dueDate: {
        path: "/due-date",
        name: "DUE_DATE",
        title: "DUE_DATE",
        permission: appPermissions.report.dueDate,
        layout: layouts.portalLayout,
        icon: CalendarOutlined,
      },
      quickCollection: {
        path: "/quick-collection",
        name: "QUICK_COLLECTION",
        title: "QUICK_COLLECTION",
        permission: appPermissions.report.quickCollection,
        layout: layouts.portalLayout,
        icon: CreditCardOutlined,
      },
      revenueStatement: {
        path: "/revenue-statement",
        name: "REVENUE_STATEMENT",
        title: "REVENUE_STATEMENT",
        permission: appPermissions.report.revenueStatement,
        layout: layouts.portalLayout,
        icon: LineChartOutlined,
      },
      salesStatus: {
        path: "/sales-status",
        name: "SALES_STATUS",
        title: "SALES_STATUS",
        permission: appPermissions.report.saleStatus,
        layout: layouts.portalLayout,
        icon: BarChartOutlined,
      },
      debitNote: {
        path: "/debit-note",
        name: "DEBIT_NOTE",
        title: "DEBIT_NOTE",
        permission: appPermissions.report.debitNote,
        layout: layouts.portalLayout,
        icon: FileTextOutlined,
      },
      arAging: {
        path: "/ar-aging",
        name: "AR_AGING",
        title: "AR_AGING",
        permission: appPermissions.report.aging,
        layout: layouts.portalLayout,
        icon: DollarOutlined,
      },
      agingSum: {
        path: "/aging-sum",
        name: "AGING_SUM",
        title: "AGING_SUM",
        permission: appPermissions.report.aging,
        layout: layouts.portalLayout,
        icon: DollarOutlined,
      },
      agingGroup: {
        path: "/aging-group",
        name: "AGING_GROUP",
        title: "AGING_GROUP",
        permission: appPermissions.report.aging,
        layout: layouts.portalLayout,
        icon: DollarOutlined,
      },
      welcome: {
        path: "/",
        title: "WELCOME_PAGE",
        name: "WELCOME_PAGE",
        layout: layouts.portalLayout,
      },


      // Portal
      accountLogout: {
        path: "/logout",
        permission: "",
        title: "Logout",
        name: "LOGOUT",
        layout: layouts.portalLayout,
        icon: LogoutOutlined,
      },

      exception: {
        path: "/exception",
        permission: "",
        title: "exception",
        name: "EXCEPTION",
        layout: layouts.portalLayout,
        icon: ExceptionOutlined,
      },

      notification: {
        path: "/user-notification",
        name: "USER_NOTIFICATION",
        permission: "",
        title: "User Notification",
        layout: layouts.portalLayout,
        icon: RadarChartOutlined,
      },

      // Notification Center (R6.3–R6.6): list sort desc + filter + mark-all-read + deep link
      notificationCenter: {
        path: "/notification-center",
        name: "NOTIFICATION_CENTER",
        permission: "",
        title: "Notification Center",
        layout: layouts.portalLayout,
        icon: Bell,
      },
      //TODO: pmh

      settings: {
        path: "/settings",
        name: "SETTINGS",
        title: "SETTINGS",
        permission: appPermissions.setting.page,
        layout: layouts.portalLayout,
        icon: ToolOutlined,
      },

      userGuideManagement: {
        path: "/user-guide-management",
        name: "USER_GUIDE_MANAGEMENT",
        title: "userGuideManagement",
        permission: appPermissions.userGuide.read,
        layout: layouts.portalLayout,
        icon: ReadOutlined,
      },

      // Download Request Center — nhật ký mọi lượt tải dữ liệu của TOÀN BỘ người dùng.
      //
      // Gate bằng `viewAll`, KHÔNG phải `read`: đây là màn quản trị/audit, nó hiển thị yêu cầu của
      // người khác. `read` được seed đại trà cho mọi role (xem
      // `download-request-center-permissions.sql`) nên gate bằng `read` thì ai cũng xem được vết tải
      // của người khác. Yêu cầu của CHÍNH người dùng nằm ở tab trong /my-pending-tasks, chỉ cần `read`.
      //
      // ⚠️ `viewAll` KHÔNG được seed đại trà — phải chạy `download-center-viewall-admin.sql` sau
      // deploy, nếu không menu này ẩn với tất cả mọi người.
      downloadCenter: {
        path: "/download-center",
        name: "DOWNLOAD_CENTER",
        title: "downloadCenter",
        permission: appPermissions.downloadRequest.viewAll,
        layout: layouts.portalLayout,
        icon: CloudDownloadOutlined,
      },

      // SKL
      potentialCustomers: {
        path: "/potential-customers",
        name: "POTENTIAL_CUSTOMERS", //KH tiềm năng
        title: "potentialCustomers",
        permission: appPermissions.customer.page,
        layout: layouts.portalLayout,
        icon: UsersThree,
      },
      existingCustomers: {
        path: "/existing-customers",
        name: "EXISTING_CUSTOMERS", // KH hiện hữu
        title: "existingCustomers",
        permission: appPermissions.existingCustomer.page,
        layout: layouts.portalLayout,
        icon: SmileOutlined,
      },
      opportunity: {
        path: "/opportunity",
        name: "OPPORTUNITY",
        permission: appPermissions.inquiry.page,
        title: "opportunity",
        layout: layouts.portalLayout,
        icon: SearchOutlined,
      },

      salePolicy: {
        path: "/sale-policy",
        name: "SALE_POLICY",
        title: "salePolicy",
        layout: layouts.portalLayout,
        permission: appPermissions.salesPolicy.page,
        icon: Notebook,
      },

      requestPriceAndSalePolicy: {
        path: "/request-price-&-sale-policy",
        name: "REQUEST_PRICE_&_SALE_POLICY",
        title: "requestPrice&SalePolicy",
        layout: layouts.portalLayout,
        permission: appPermissions.pricingApproval.page,
        icon: Notebook,
      },
      reservation: {
        path: "/booking",
        name: "BOOKING",
        title: "booking",
        layout: layouts.portalLayout,
        permission: appPermissions.booking.page,
        icon: Bell,
      },
      saleEvent: {
        path: "/sale-event",
        name: "SALE_EVENT_BATCH",
        title: "SaleEvent",
        layout: layouts.portalLayout,
        permission: appPermissions.salesEvent.page,
        icon: Cannon,
      },
      processSaleEventsCheckinGate: {
        path: "/checkin-gate",
        name: "CHECKIN_GATE",
        title: "checkinGate",
        layout: layouts.portalLayout,
        permission: appPermissions.salesEvent.page,
        icon: LoginOutlined,
      },
      processSaleEventsCheckinBalloting: {
        path: "/checkin-balloting",
        name: "CHECKIN_BALLOTING",
        title: "checkinBalloting",
        layout: layouts.portalLayout,
        permission: appPermissions.salesEvent.page,
        icon: OrderedListOutlined,
      },
      processSaleEventsCheckinSTT: {
        path: "/checkin-stt",
        name: "CHECKIN_STT",
        title: "checkinStt",
        layout: layouts.portalLayout,
        permission: appPermissions.salesEvent.page,
        icon: FieldNumberOutlined,
      },
      processSaleEventsCheckinOnline: {
        path: "/checkin-online",
        name: "CHECKIN_ONLINE",
        title: "checkinOnline",
        layout: layouts.portalLayout,
        permission: appPermissions.salesEvent.page,
        icon: EnvironmentOutlined,
      },
      contract: {
        path: "/contract",
        name: "CONTRACT",
        title: "contract",
        layout: layouts.portalLayout,
        permission: appPermissions.contract.page,
        icon: Contract,
      },
      floorAndStaff: {
        path: "/agency-and-staff",
        name: "FLOOR_AND_STAFF",
        title: "floorAndStaff",
        permission: appPermissions.agencyMaster.page,
        layout: layouts.portalLayout,
        icon: UsersTwo,
      },

      stackingPlan: {
        path: "/stacking-plan",
        name: "STACKING_PLAN",
        title: "stacking plan",
        layout: layouts.portalLayout,
        permission: appPermissions.masterData.project.stackingPlan,

        icon: CompassOutlined,
      },
      // after sale
      notifications: {
        path: "/notifications",
        name: "NOTIFICATIONS",
        title: "notifications",
        layout: layouts.portalLayout,
        permission: appPermissions.feeNotification.page,

        icon: HandSpeaker,
      },
        /**
         * Cấu hình thang nhắc phí KHÔNG còn route riêng: nó là tab bánh răng trong `/notifications`.
         */
      notificationCenterSettings: {
        path: "/notification-center/settings",
        name: "NOTIFICATION_CENTER_SETTINGS",
        title: "notification center settings",
        layout: layouts.portalLayout,
        permission: "",

        icon: HandSpeaker,
      },
      income: {
        path: "/income",
        name: "INCOME",
        title: "income",
        layout: layouts.portalLayout,
        incomeModule: true,
        icon: CurrencyDollarIcon,
        // Route cũ — scene chỉ redirect sang /income-contract (giữ bookmark/deep link).
      },
      incomeBooking: {
        path: "/income-booking",
        name: "INCOME_BOOKING",
        title: "incomeBooking",
        layout: layouts.portalLayout,
        incomeModule: true,
        icon: TicketIcon,
      },
      incomeContract: {
        path: "/income-contract",
        name: "INCOME_CONTRACT",
        title: "incomeContract",
        layout: layouts.portalLayout,
        incomeModule: true,
        icon: DocumentTextIcon,
      },
      handover: {
        path: "/handover",
        name: "HANDOVER_MANAGEMENT",
        title: "handover",
        layout: layouts.portalLayout,
        permission: appPermissions.handoverPlan.page,
        icon: HandSpeaker,
      },
      houseOwnershipCertificate: {
        path: "/house-ownership-certificate",
        name: "HOUSE_OWNERSHIP_CERTIFICATE",
        title: "houseOwnershipCertificate",
        permission: appPermissions.pinkBook.page,
        layout: layouts.portalLayout,
        icon: Notebook,
      },

      // Cart Management
      cartManagement: {
        path: "/cart-management",
        name: "CART",
        title: "cardManagement",
        layout: layouts.portalLayout,
        permission: appPermissions.cart.read,
        icon: ShoppingCartOutlined,
      },

      // Notification Delivery Tracking (accounting notification dashboard)
      notificationTracking: {
        path: "/notification-tracking",
        name: "NOTIFICATION_DELIVERY_TRACKING",
        title: "notificationTracking",
        layout: layouts.portalLayout,
        permission: appPermissions.cart.read,
        icon: BarChartOutlined,
      },

      // Notification Audit Log (Accounting)
      notificationAuditLog: {
        path: "/notification-audit-log",
        name: "AUDIT_LOG_TITLE",
        title: "notificationAuditLog",
        layout: layouts.portalLayout,
        permission: appPermissions.notificationAuditLog.read,
        icon: FileTextOutlined,
      },

      // Feeback
      feedbacks: {
        path: "/feedbacks",
        name: "FEEDBACKS",
        title: "feedbacks",
        layout: layouts.portalLayout,
        permission: appPermissions.feedback.page,
        icon: CommentOutlined,
      },
      feedbackConfig: {
        path: "/feedback-config",
        name: "FEEDBACK_CONFIG",
        title: "feedbackConfig",
        permission: appPermissions.feedback.page,
        layout: layouts.portalLayout,
        icon: SettingOutlined,
      },
      handoverManagement: {
        path: "/handover-management",
        name: "HANDOVER_MANAGEMENT",
        permission: appPermissions.handoverPlan.page,
        title: "handoverManagement",
        layout: layouts.portalLayout,
        icon: Key,
      },
      // config
      masterData: {
        path: "/master-data",
        name: "MASTER_DATA",
        title: "masterData",
        permission: appPermissions.masterData.page,
        layout: layouts.portalLayout,
        icon: MasterData,
      },
      accountingData: {
        path: "/accouting-data",
        name: "ACCOUNTING_DATA",
        title: "accoutingData",
        permission: appPermissions.masterData.page,
        layout: layouts.portalLayout,
        icon: MasterData,
      },
      // Master Data

      project: {
        path: "/projects",
        name: "PROJECT",
        title: "project",
        layout: layouts.portalLayout,
        permission: appPermissions.masterData.project.read,
        icon: InsertRowBelowOutlined,
      },
      products: {
        path: "/products",
        name: "PRODUCTS",
        title: "products",
        permission: appPermissions.masterData.unitMasterData.read,
        layout: layouts.portalLayout,
        icon: HomeOutlined,
      },
      administration: {
        path: "/system-settings",
        name: "SYSTEM_SETTINGS",
        title: "systemSettings",
        permission: appPermissions.masterData.page,
        // permission: appPermissions.system.page,
        layout: layouts.portalLayout,
        icon: SettingOutlined,
      },
      syncManagement: {
        path: "/sync-management",
        name: "SYNC_MANAGEMENT",
        title: "syncManagement",
        layout: layouts.portalLayout,
        icon: SyncOutlined,
        permission: appPermissions.integrationResult.page,
      },

      // Integration Hub
      integrationHub: {
        path: "/integration-hub",
        name: "INTEGRATION_HUB",
        title: "integrationHub",
        layout: layouts.portalLayout,
        icon: SyncOutlined,
        permission: appPermissions.integrationHub.page,
      },
      integrationHubDashboard: {
        path: "/integration-hub/dashboard",
        name: "INTEGRATION_HUB_DASHBOARD",
        title: "integrationHubDashboard",
        layout: layouts.portalLayout,
        icon: SyncOutlined,
        permission: appPermissions.integrationHub.dashboard,
      },
      integrationHubConfiguration: {
        path: "/integration-hub/configuration",
        name: "INTEGRATION_HUB_CONFIGURATION",
        title: "integrationHubConfiguration",
        layout: layouts.portalLayout,
        icon: SyncOutlined,
        permission: appPermissions.integrationHub.configuration,
      },

      // Approval Inbox Outbox
      approvalInboxOutbox: {
        path: "/my-pending-tasks",
        name: "MY_PENDING_TASKS",
        title: "myPendingTasks",
        layout: layouts.portalLayout,
        icon: ExceptionOutlined,
      },

      // Deep link vào một phiếu cụ thể: /my-pending-tasks/{requestId}.
      // Trỏ cùng scene approvalInboxOutbox; scene tự đọc :requestId để mở chi tiết.
      // KHÔNG khai báo trong menu (chỉ dùng cho điều hướng deep link).
      approvalInboxOutboxDetail: {
        path: "/my-pending-tasks/:requestId",
        name: "MY_PENDING_TASKS",
        title: "myPendingTasks",
        layout: layouts.portalLayout,
        icon: ExceptionOutlined,
      },
    }

export const routers: any = {
  ...userLayout,
  ...portalLayouts,
}

export const appMenuGroups: any =
  hostname === process.env.REACT_APP_EVENT_URL
    ? [
      routers.eventProgess,
      routers.eventDrawLots,
      routers.pickUnits,
      routers.stackingLand,
    ]
    : [
      routers.approvalInboxOutbox,
      {
        name: "DASHBOARD_REPORT_TITLE",
        icon: HomeOutlined,
        permissions: [],
        children: [
          // Executive trên cùng (tổng hợp xuyên phân hệ), rồi SA/ACC — Feature-0196 Requirement 7.1
          routers.dashboardExecutive,
          routers.dashboard,
          routers.dashboardSales,
          routers.dashboardFinance,
          routers.dailyCollection,
          routers.dueDate,
          routers.quickCollection,
          routers.revenueStatement,
          routers.salesStatus,
          routers.debitNote,
          routers.arAging,
          routers.agingSum,
          routers.agingGroup,
        ],
      },
      {
        name: "SALES",
        // type: "group",
        icon: ShoppingCartOutlined,
        permissions: [
          appPermissions.customer.page,
          appPermissions.salesEvent.page,
          appPermissions.salesPolicy.page,
          appPermissions.contact.page,
          appPermissions.agencyMaster.page,
          appPermissions.inquiry.page,
          appPermissions.cart.read,
          appPermissions.notificationAuditLog.read,
        ],
        children: [
          routers.existingCustomers,
          routers.potentialCustomers,
          routers.opportunity,
          routers.cartManagement,
          // TODO[tạm ẩn]: 2 menu của Feature-0169 (accounting notification).
          // Route vẫn còn nên deep link /notification-tracking và
          // /notification-audit-log vẫn vào được; bỏ comment để hiện lại trên menu.
          // routers.notificationTracking,
          // routers.notificationAuditLog,
          routers.stackingPlan,
          routers.salePolicy,
          routers.requestPriceAndSalePolicy,
          routers.reservation,
          {
            name: "SALE_EVENT",
            icon: RocketOutlined,
            permission: appPermissions.salesEvent.page,
            children: [
              routers.saleEvent,
              routers.processSaleEventsCheckinGate,
              routers.processSaleEventsCheckinBalloting,
              routers.processSaleEventsCheckinSTT,
              routers.processSaleEventsCheckinOnline,
            ],
          },
          routers.contract,
          routers.floorAndStaff,
          // routers.tradingFloor,
        ],
      },
      {
        name: "AFTER_SALES",
        // type: "group",
        icon: Headphone,
        permissions: [
          appPermissions.feeNotification.page,
          appPermissions.feeNotification.setting,
          appPermissions.report.feeNotification,
          appPermissions.contractInquiry.read,
          appPermissions.contractInquiry.create,
          appPermissions.contractInquiry.update,
          appPermissions.contractInquiry.invoiceIntegration,
          appPermissions.contractInquiry.accountingIntegration,
          appPermissions.handoverPlan.page,
          appPermissions.handoverReservation.page,
          appPermissions.pinkBook.page,
          appPermissions.feedback.page,
        ],
        children: [
          // Dashboard CS đứng đầu group hậu mãi — Feature-0196 Requirement 7.1
          routers.dashboardCs,
          /**
           * Thông báo phí: **MỘT mục menu duy nhất**. Báo cáo thông báo phí giờ là một TAB bên
           * trong `/notifications` (đứng trước tab bánh răng cấu hình thang nhắc), không còn mục
           * menu riêng — route `/fee-notification-report` vẫn giữ trong `router.config.ts` để link
           * cũ và badge header (`?tab=backlog`) tiếp tục chạy.
           *
           * Giữ `permissions` (số nhiều) của nhóm cũ: người chỉ có quyền xem báo cáo hoặc chỉ có
           * quyền cấu hình vẫn thấy mục này — `SiderMenu` xét `isGrantedAny(...permissions)`.
           */
          {
            ...routers.notifications,
            name: "FEE_NOTIFICATION_GROUP_MENU",
            icon: SoundOutlined,
            permissions: [
              appPermissions.feeNotification.page,
              appPermissions.feeNotification.setting,
              appPermissions.report.feeNotification,
            ],
          },
          {
            // Menu cha "Phiếu thu" — không có path, chỉ để nhóm 2 menu con.
            name: "INCOME",
            icon: CurrencyDollarIcon,
            incomeModule: true,
            children: [routers.incomeBooking, routers.incomeContract],
          },
          routers.handoverManagement,
          routers.houseOwnershipCertificate,
          {
            name: "FEEDBACKS_MANAGEMENT",
            icon: Headphone,
            permission: appPermissions.feedback.page,
            children: [routers.feedbacks, routers.feedbackConfig],
          },
        ],
      },
        {
          name: "CONFIG",
          // type: "group",
          icon: SettingOutlined,
          permissions: [
            appPermissions.masterData.page,
            appPermissions.system.page,
            appPermissions.setting.page,
            appPermissions.integrationHub.page,
            appPermissions.userGuide.read
          ],
          title: "CONFIG",
          children: [
            routers.masterData,
            // routers.accountingData,
            // routers.project,
            routers.products,

          routers.administration,
          // routers.approvalInboxOutbox,
          // routers.syncManagement, // Removed: replaced by Integration Hub
          {
            name: "INTEGRATION_HUB_MENU",
            icon: SyncOutlined,
            permission: appPermissions.integrationHub.page,
            children: [
              routers.integrationHub,
              routers.integrationHubDashboard,
              routers.integrationHubConfiguration,
            ],
          },
          routers.settings,
          routers.userGuideManagement,
          // Trung tâm tải dữ liệu — đặt cuối cụm CONFIG theo yêu cầu nghiệp vụ.
          routers.downloadCenter,
        ],
      },
    ]
